import { render, staticRenderFns } from "./AutoMessage.vue?vue&type=template&id=7589fa01&scoped=true&"
import script from "./AutoMessage.vue?vue&type=script&lang=js&"
export * from "./AutoMessage.vue?vue&type=script&lang=js&"
import style0 from "./AutoMessage.vue?vue&type=style&index=0&id=7589fa01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7589fa01",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCard,VCardText,VCheckbox})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7589fa01')) {
      api.createRecord('7589fa01', component.options)
    } else {
      api.reload('7589fa01', component.options)
    }
    module.hot.accept("./AutoMessage.vue?vue&type=template&id=7589fa01&scoped=true&", function () {
      api.rerender('7589fa01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Message/components/AutoMessage.vue"
export default component.exports